/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Actions_LabelInputs */

const en_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata actions`)
};

const fr_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions des métadonnées`)
};

const de_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenaktionen`)
};

const it_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni sui metadati`)
};

const ru_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия с метаданными`)
};

const es_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones de metadatos`)
};

const zh_cn2_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据操作`)
};

const ja_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータアクション`)
};

const hi_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा क्रियाएँ`)
};

const pt_pt2_event_group_metadata_actions_label = /** @type {(inputs: Event_Group_Metadata_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações de metadados`)
};

/**
* | output |
* | --- |
* | "Metadata actions" |
*
* @param {Event_Group_Metadata_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_actions_label = /** @type {((inputs?: Event_Group_Metadata_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_actions_label(inputs)
	if (locale === "de") return de_event_group_metadata_actions_label(inputs)
	if (locale === "it") return it_event_group_metadata_actions_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_actions_label(inputs)
	if (locale === "es") return es_event_group_metadata_actions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_actions_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_actions_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_actions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_actions_label(inputs)
	return en_event_group_metadata_actions_label(inputs)
});